module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/rever/logo-r-red@1x.png"